import React, { useState, useEffect } from 'react';
import { browserHistory } from 'react-router';

import { Form, Card, message } from 'antd';
import { AntdPageHeader, ButtonGroup, Center, ContentWrapper } from '@yuhuinc/ui-library';
import { LoadingOutlined } from '@ant-design/icons';

import StepForm from './Steps/StepForm';

import {
  translationsToObject,
  getTemplate,
  getTemplateStep,
  updateTemplateStep,
  createTemplateStepBlocks,
} from './store/actions';
import { getTranslatedString } from 'helpers/i18n';

const saveButtonText = getTranslatedString('landlordPortal.applicationTemplate.actions.save');
const saveStepSuccessText = getTranslatedString(
  'landlordPortal.applicationTemplate.messages.saveStep.success'
);
const saveStepErrorText = getTranslatedString(
  'landlordPortal.applicationTemplate.messages.saveStep.error'
);

const EditStep = ({ routeParams, location }) => {
  const [templateStepForm] = Form.useForm();
  const [step, setStep] = useState(null);

  const toEditApplicationTemplate = (flashMessage) =>
    browserHistory.push(
      `/companies/application_templates/${step.application_template_id}/edit${
        flashMessage && typeof flashMessage === 'string'
          ? `?flashMessage=${encodeURIComponent(flashMessage)}`
          : ''
      }`
    );

  const handleSave = () => {
    templateStepForm.validateFields().then((values) => {
      updateTemplateStep(step.application_template_id, step.id, values)
        .done(() => {
          createTemplateStepBlocks(step.application_template_id, step.id, values.blocks).done(() =>
            toEditApplicationTemplate(saveStepSuccessText)
          );
        })
        .catch(() => message.error(saveStepErrorText));
    });
  };

  useEffect(() => {
    if (location.query.flashMessage) {
      message.success(location.query.flashMessage);
    }
  }, []);

  useEffect(() => {
    getTemplateStep(routeParams.applicationTemplateId, routeParams.stepId).then(
      ({ application_template_step }) => setStep(application_template_step)
    );
  }, [getTemplate, getTemplateStep, routeParams]);

  return (
    <div className="body" role="main">
      {!step ? (
        <Center>
          <LoadingOutlined style={{ fontSize: 24 }} spin />
        </Center>
      ) : (
        <>
          <AntdPageHeader
            onBack={toEditApplicationTemplate}
            title={getTranslatedString('landlordPortal.applicationTemplate.steps.edit')}
            extra={[<ButtonGroup buttons={[{ label: saveButtonText, onClick: handleSave }]} />]}
          />

          <ContentWrapper>
            <Card style={{ maxWidth: 566 }}>
              <StepForm
                form={templateStepForm}
                formName={'edit_application_template_step'}
                stepIndex={step.sorting_index}
                stepData={step}
              />
            </Card>
          </ContentWrapper>
        </>
      )}
    </div>
  );
};

export default EditStep;
